import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA4, trackPageView } from '../lib/analytics';

export const GA4RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    initGA4();
  }, []);

  useEffect(() => {
    trackPageView(location);
  }, [location.pathname, location.search]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default GA4RouteTracker;
